import { Fragment } from 'react'

import classNames from 'classnames/bind'
import PropTypes from 'prop-types'

import styles from './Title.module.scss'

const cx = classNames.bind(styles)

const Title = ({ preTitle, title, subtitle, classes }) => {
  const preTitles = Array.isArray(preTitle)
    ? preTitle.map((item) => (
      <Fragment key={`${item}-pretitle`}>
        {item}
        <br />
      </Fragment>
    ))
    : false
  const titles = Array.isArray(title)
    ? title.map((item) => (
      <Fragment key={`${item}-title`}>
        {item}
        <br />
      </Fragment>
    ))
    : false
  const subtitles = Array.isArray(subtitle)
    ? subtitle.map((item) => (
      <Fragment key={`${item}-subtitle`}>
        {item}
        <br />
      </Fragment>
    ))
    : false
  const wrapperClasses = classes
    ? `${styles.titleWrapper} ${cx(classes)}`
    : styles.titleWrapper
  return (
    <div className={wrapperClasses}>
      {(preTitles || preTitle) && (
        <h3 className={styles.pretitle}>{preTitles || preTitle}</h3>
      )}
      <h2 className={styles.title}>{titles || title}</h2>
      {(subtitles || subtitle) && (
        <h3 className={styles.subtitle}>{subtitles || subtitle}</h3>
      )}
    </div>
  )
}

Title.propTypes = {
  classes: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  preTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    ),
  ]),
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    ),
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    ),
  ]),
}

Title.defaultProps = {
  classes: {},
  preTitle: null,
  subtitle: '',
  title: null,
}

export default Title
